<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">参与的每一个活动，</p>
        <p  class="font1" style="padding-top: 1vh;">获得的每一张证书，</p>
        <p  class="font1" style="padding-top: 1vh;">都是你不断追求卓越的印记～</p>
        <p  class="font1" style="padding-top: 1vh;">坚持不懈地学习与成长，</p>
        <p  class="font1" style="padding-top: 1vh;">你的职场之路将更加宽广</p>

        <div class="container" v-if="certificate">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">获得荣誉：</p>
            <ul v-for="(item,index) in certificate" :key="index">
                <li>{{ item }}</li>
            </ul>
        </div>

        <p class="font1" style="color: #7126d3;margin-top: 5vh;">{{ ReportData.textLab.text }}</p>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    components: {},
    data() {
        return {
            certificate:[],
        }
    }, 
    created(){
        if(this.ReportData.activityJinggan){
            this.certificate= this.ReportData.activityJinggan.split(/[,，]/) .map(item => item.trim().replace(/^["“”']+|["“”']+$/g, '')) .filter(item => item); 
        }
    },
    computed:{},
    mounted(){
        
    }
}
</script>

<style scoped>
.body {
    background: 
                url("../../assets/25July/logo.png") right  top  no-repeat,
                url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/25July/bg.jpg")  no-repeat;
    background-size:100% 100%, 55%,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #7126d3;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #7126d3;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.container{
        max-width: 350px;
        margin-top: 30px;
        padding: 30px;
        margin: 0 auto;
        background-color: #dbbce1;
        border-radius: 10px;
        border: #fff solid 1px;
        text-align: center;
}
@media screen and (min-width: 786px) {
    .body {
        background: 
                    url("../../assets/25July/pcbg.jpg")  no-repeat;
        background-size:cover;
        width: 100%;
        height: 100vh;
    }

    .font1 {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-size: 20px;
        color: #7126d3;
        font-weight: bold;
        font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
    }

    .font2{
        font-size: 19px;
    }

    .font3{
        font-size: 24px;
    }
    .container{
        max-width: 450px;
        margin-top: 30px;
        padding: 30px;
        margin: 0 auto;
        background-color: #dbbce1;
        border-radius: 10px;
        border: #fff solid 1px;
        text-align: center;
    }
}
</style>